"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/**
 * Manual route tracking with multi-MFE coordination
 * App-shells track routes, feature MFEs don't (prevents duplicates)
 */

import { getDataDogRUM } from './agent';
const ROUTE_TRACKER_KEY = '__AG_DATADOG_ROUTE_TRACKER__';
export const registerAsRouteTracker = mfeId => {
  if (!process.__browser__) return false;
  if (window[ROUTE_TRACKER_KEY]) {
    if (window[ROUTE_TRACKER_KEY] === mfeId) return true;
    if (process.env.NODE_ENV !== "production") {
      console.log(`[DataDog] ${mfeId} skipped - tracker already registered`);
    }
    return false;
  }
  window[ROUTE_TRACKER_KEY] = mfeId;
  if (process.env.NODE_ENV !== "production") {
    console.log(`[DataDog] ${mfeId} registered as route tracker`);
  }
  return true;
};
export const isRouteTracker = mfeId => {
  return process.__browser__ && window[ROUTE_TRACKER_KEY] === mfeId;
};
export const trackDataDogView = (viewName, options) => {
  try {
    const datadog = getDataDogRUM();
    if (!datadog) {
      if (process.env.NODE_ENV !== "production") {
        console.warn('[DataDog] SDK not available, skipping view tracking');
      }
      return;
    }
    if (options !== null && options !== void 0 && options.context) {
      for (const [key, value] of Object.entries(options.context)) {
        datadog.setGlobalContextProperty(key, value);
      }
    }
    datadog.startView({
      name: viewName,
      service: options === null || options === void 0 ? void 0 : options.service,
      version: options === null || options === void 0 ? void 0 : options.version
    });
    if (process.env.NODE_ENV !== "production") {
      console.log(`[DataDog] View tracked: ${viewName}`, options);
    }
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
      console.warn('[DataDog] Failed to track view:', error);
    }
  }
};
export const getCurrentRouteTracker = () => {
  return process.__browser__ ? window[ROUTE_TRACKER_KEY] : undefined;
};